import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface KbgProps {
  className?: string;
}

const Kbd = ({ className, children }: PropsWithChildren<KbgProps>) => {
  return (
    <kbd
      className={twMerge(
        'rounded inline-block mx-[3px] px-1 min-w-[20px] text-center transition-colors bg-neutral-100 hover:bg-neutral-200 capitalize text-[11px] leading-5 font-medium',
        className,
      )}
      style={{ fontFamily: 'var(--font-family-code)' }}
    >
      {children}
    </kbd>
  );
};

export default Kbd;
